
import { computed, defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';
import Button from 'primevue/button';

export default defineComponent({
  name: 'WhatsappOnboardingNav',

  components: {
    Button,
  },

  props: {
    showBack: { type: Boolean, default: false },
    showNext: { type: Boolean, default: false },
    showConnect: { type: Boolean, default: false },
    canGoNext: { type: Boolean, default: true },
    connectLoading: { type: Boolean, default: false },
    isIntroStep: { type: Boolean, default: false },
  },

  emits: ['back', 'next', 'connect'],

  setup(props) {
    const { t } = useI18n();

    const nextButtonLabel = computed(() => (
      props.isIntroStep
        ? t('storeParameters.services.whatsappBusinessParameter.onboarding.intro.cta')
        : t('storeParameters.services.whatsappBusinessParameter.onboarding.nav.next')
    ));

    return {
      t,
      nextButtonLabel,
    };
  },
});
